import React from 'react';
import wrapWithProvider from '@Utils/Components/wrapWithProvider';
import ToastCollectionHost from './ToastCollectionHost';

const renderToastCollectionHost = wrapWithProvider(<ToastCollectionHost />);

export default function init() {
  const root = document.createElement('div');
  root.setAttribute('class', 'toast-message-root');
  document.body.appendChild(root);

  renderToastCollectionHost(root);
}
